export default "__VITE_ASSET__CWfstXLa__"